import { createRequestTypes } from '../utils';

export const PHRASE_LIST = createRequestTypes('phrases/PHRASE_LIST');
export const GET_PHRASE = createRequestTypes('phrases/GET_PHRASE');
export const SAVE_PHRASE = createRequestTypes('phrase/SAVE_PHRASE');
export const DELETE_PHRASE = createRequestTypes('phrase/DELETE_PHRASE');
export const UPDATE_PHRASE = 'phrase/UPDATE_PHRASE';
